import { useContext, useState } from "react";
import { AppContext } from "../../../context/AppContext";
import { RegisterChargebee } from "../ChargebeeRegistration";
import { Button } from "antd";
import { Chargebee_CHARGE_NAME } from "../../../constants/AppConstants";
import CreditsSuccessModal from "./CreditsSuccessModal";

const BuyFunds = () => {
    const [appProperties, setAppProperties] = useContext(AppContext);
    const [successModal, setSuccessModal] = useState(false);
    function registerAgain() {
        RegisterChargebee("Omni", appProperties, setAppProperties, setSuccessModal);
    }
    return (
        <>
            <Button
                data-cb-type="checkout"
                data-cb-item-0={Chargebee_CHARGE_NAME}
                data-cb-item-0-quantity="1"
                type="link"
                onMouseEnter={registerAgain}
            >
                Add Funds
            </Button>
            {successModal ? (
                <CreditsSuccessModal
                    successModal={successModal}
                    setSuccessModal={setSuccessModal}
                    handleClickDomainUrl={null}
                />
            ) : null}
        </>
    );
};

export default BuyFunds;
